import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { operations } from './generated/gcss';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { apiGcssFetcher } from '../fetcher';
import { GCSS_URLS } from '@/constants/api';
export type MerchantsListResponse = operations['merchants']['responses']['200']['content']['application/json'] | undefined;
type MerchantsRequest = operations['merchants']['parameters']['query'];
export function useMerchants(t0) {
  const $ = _c(11);
  let enabled;
  let params;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      enabled,
      ...params
    } = t0);
    t2 = useQuery;
    t1 = QUERY_KEYS.gcssMerchants(params);
    $[0] = t0;
    $[1] = enabled;
    $[2] = params;
    $[3] = t1;
    $[4] = t2;
  } else {
    enabled = $[1];
    params = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== params) {
    t3 = async t4 => {
      const {
        signal
      } = t4;
      const res = await apiGcssFetcher(GCSS_URLS.merchantsList, {
        searchParams: params,
        signal
      });
      const results = await res.json;
      return (results || []).map(_temp);
    };
    $[5] = params;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== enabled || $[8] !== t1 || $[9] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t3,
      enabled,
      placeholderData: keepPreviousData,
      staleTime: 300000,
      refetchOnWindowFocus: false,
      retry: 1,
      retryDelay: 1000
    };
    $[7] = enabled;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t2(t4);
}
function _temp(merchant) {
  return {
    label: merchant.name,
    value: merchant.name
  };
}